import { render, staticRenderFns } from "./MapiProjectDetail.vue?vue&type=template&id=47ad1637&"
import script from "./MapiProjectDetail.vue?vue&type=script&lang=js&"
export * from "./MapiProjectDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports